import { render, staticRenderFns } from "./ExerciseDetailsPivotTable.vue?vue&type=template&id=071dd9a1&scoped=true&"
import script from "./ExerciseDetailsPivotTable.vue?vue&type=script&lang=js&"
export * from "./ExerciseDetailsPivotTable.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseDetailsPivotTable.vue?vue&type=style&index=0&id=071dd9a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071dd9a1",
  null
  
)

export default component.exports